import { useAnalyticsMonth } from "@/routes/custom-music/dsp-analytics/context/dsp-analytics-context";
import { getMonthCount } from "@/utils/time";
import { Button, Popover, PopoverContent, PopoverTrigger, Typography } from "@backpac/monica";
import { MonthRangePicker } from "@backpac/monica";
import { CalendarIcon } from "lucide-react";
import { useState } from "react";
import { Temporal } from "temporal-polyfill";

export const MonthRangeSelect = () => {
  const { selectedMonthRange, setSelectedMonthRange } = useAnalyticsMonth();
  const [monthRange, setMonthRange] = useState<[Temporal.PlainDate, Temporal.PlainDate] | undefined>(
    selectedMonthRange ? selectedMonthRange : undefined,
  );

  const [open, setOpen] = useState(false);

  const formatMonthRange = (range: [Temporal.PlainDate, Temporal.PlainDate] | undefined) => {
    if (!range) return "";

    const [start, end] = range;
    const startMonth = start.toLocaleString("en-US", { month: "short" });
    const endMonth = end.toLocaleString("en-US", { month: "short" });

    return `${startMonth}, ${start.year} - ${endMonth}, ${end.year}`;
  };

  const calculateMonthsBetween = (range: [Temporal.PlainDate, Temporal.PlainDate] | undefined) => {
    if (!range) return 0;

    return getMonthCount(range[0], range[1]);
  };

  const handleApply = () => {
    if (monthRange) {
      setSelectedMonthRange(monthRange);
      setOpen(false);
    }
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Typography asChild size="xs" weight={600} color="textPrimary">
          <Button variant="outlined">
            <CalendarIcon className="mr-2 h-4 w-4" />
            {selectedMonthRange ? formatMonthRange(selectedMonthRange) : "Select date range"}
          </Button>
        </Typography>
      </PopoverTrigger>

      <PopoverContent className="w-auto p-0" align="start">
        <div className="flex flex-col w-full">
          <div className="p-4 text-center border-b">
            <Typography size="lg" weight={600}>
              Date-range
            </Typography>
          </div>

          <MonthRangePicker
            selectedMonthRange={monthRange}
            onMonthRangeSelected={setMonthRange}
            maxMonth={Temporal.Now.plainDateISO()}
          />

          {selectedMonthRange && (
            <div className="p-4 text-center border-t">
              <Typography size="sm" weight={500} className="mb-4">
                {selectedMonthRange[0].toLocaleString("en-US", { month: "short" })} {selectedMonthRange[0].year} -{" "}
                {selectedMonthRange[1].toLocaleString("en-US", { month: "short" })} {selectedMonthRange[1].year} (
                {calculateMonthsBetween(selectedMonthRange)} mos)
              </Typography>

              <Button
                variant="black"
                className="w-full bg-gray-800 hover:bg-gray-700 text-white rounded-full"
                onClick={handleApply}
                disabled={!monthRange}
              >
                Apply
              </Button>
            </div>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
};
